// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"e644a3b4","453":"3bf4e4a8","849":"dd2759e4"}[chunkId] + ".chunk.js";
};